import config from './config';
import { http } from './services';

// Public auth routes that must never carry stale Authorization or
// X-Organization-Id headers from a previous session. Sending those on a
// fresh signup/login can trip the API's CORS preflight cache and confuse
// debugging — the response surfaces in the browser as an opaque
// "CORS error" instead of the real failure.
const PUBLIC_AUTH_ROUTE = /^\/?api\/auth\/(register|login|telegram|refresh|forgot-password|reset-password|login\/phone\/(start|verify|resend))(\/|\?|$)/;

http.init({
  configFn: (reqConfig) => {
    const accessToken = localStorage.getItem(config.api.access_token_key);
    const url = reqConfig.url ?? '';
    const isPublicAuth = PUBLIC_AUTH_ROUTE.test(url);

    const headers: any = {
      Accept: 'application/json',
    };

    // Only force Content-Type for non-multipart requests.
    // For FormData (file uploads), do NOT set it — Axios must set it automatically
    // so the boundary parameter is included (e.g. "multipart/form-data; boundary=----XYZ").
    // Overriding it strips the boundary and breaks multer on the server.
    if (!(reqConfig.data instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    if (accessToken && !isPublicAuth) {
      headers.Authorization = `Bearer ${accessToken}`;
    } else if (!accessToken && !isPublicAuth) {
      // No-account guest sessions: when there is no logged-in user, fall back to
      // the attempt-bound guest session token (sessionStorage). The API's
      // AttemptCallerGuard distinguishes it by its `kind: 'guest'` claim.
      const guestToken = sessionStorage.getItem(config.api.guest_token_key);
      if (guestToken) headers.Authorization = `Bearer ${guestToken}`;
    }

    // Standard SaaS pattern: send active org on every request — except on
    // public auth routes, which don't read it and shouldn't carry tenant
    // context from a previous session.
    const activeOrgId = localStorage.getItem(config.api.active_org_key);
    if (activeOrgId && !isPublicAuth) {
      headers['X-Organization-Id'] = activeOrgId;
    }

    return {
      baseURL: config.api.base_url,
      headers,
    };
  },
});
